module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "box",
    style: (_vm.getImage),
    attrs: {
      "method": "post",
      "action": "",
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    class: {
      dragging: _vm.isDragging
    },
    attrs: {
      "id": "drop-zone"
    },
    on: {
      "dragover": _vm.dragover,
      "drop": _vm.drop,
      "dragleave": _vm.dragleave,
      "dragend": _vm.dragend
    }
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "drop-zone-caption"
  }, [_vm._v("Drop Here to Replace")]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('span', {
    staticClass: "btn btn-primary btn-file",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('button', {
    staticClass: "mdl-button"
  }, [_vm._v("or CLICK HERE")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "drop-zone-file",
      "name": "files[]"
    },
    on: {
      "change": _vm.selectLocal
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "font-size": "14px",
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("LOADING...")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-db5c3974!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropzoneFirebase.vue
// module id = 320
// module chunks = 0